module.exports = __webpack_public_path__ + "static/img/undraw_pay_online.6ae9ec3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/undraw_pay_online.svg
// module id = 9ziX
// module chunks = 1